import React from 'react';
import { useAnalytics } from '../hooks/useAnalytics';

const withAnalytics = (ComponentToWrap) => {
  const WithAnalyticsComponent = (props) => {
    const { track, identify, page, ready, alias, group } = useAnalytics();
    return (
      <ComponentToWrap
        {...props}
        track={track}
        identify={identify}
        page={page}
        ready={ready}
        alias={alias}
        group={group}
      />
    );
  };

  const WithAnalyticsWrapper = (props) => <WithAnalyticsComponent {...props} />;

  WithAnalyticsWrapper.displayName = 'withAnalyticsWrapper';
  return WithAnalyticsWrapper;
};

export default withAnalytics;
